import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Use negative enquiry</div>
                                            <p>Asking a diplomatically worded question avoids sounding
                                                overtly critical (`negative assertion'), by
                                                making us appear willing to acknowledge contributing to a
                                                problem, if appropriate. For example:
                                                <span className="subtiltereg">`You've been a bit distant lately, have I done something to upset you?'</span>
                                            </p>

                                            <div className="border_subtitle">Check your body language</div>
                                            <p>Assertive body language reinforces our message, non-assertive
                                                body language confuses it. Your
                                                body language needs to be consistent with your message.
                                                However, by `assertive' we don't mean
                                                standing over someone with your hands on your hips, or
                                                poking a finger at them! We're talking
                                                about maintaining eye contact and a relaxed or customary
                                                facial expression. </p>

                                            <div className="border_subtitle">Posture and distance</div>
                                            <p>Make sure you're neither standing over the person nor
                                                appearing to distance yourself from them.
                                                If they are sitting or standing, do the same.</p>
                                            <div className="border_subtitle">Mouth</div>
                                            <p>If we're nervous we can get tense and clench our jaw or
                                                tighten our mouths. Consciously relax
                                                your face, if you can &shy; but don't smile to ingratiate
                                                yourself or mitigate what you're saying,
                                                because that, again, sends mixed messages and confuses the
                                                other person</p>
                                            <div className="border_subtitle">Voice</div>
                                            <p>Try not to mumble, as if you're unconvinced about what you're
                                                saying &shy; or talk more loudly than
                                                normal, as though discouraging any response. If you think
                                                you're doing either, stop and breathe
                                                for a moment or two. In fact, pausing every so often is
                                                another effective way to reinforce what
                                                you're saying, anyway!
                                            </p>
                                            <div className="border_subtitle">Gestures</div>
                                            <p>Try not to fiddle with your hands, your nose or twiddle your
                                                hair – you'll look nervous and unsure
                                                of yourself. On the other hand, striding about, waving your
                                                arms or pointing will look aggressive
                                                (if not a bit silly). Shrugging your shoulders may suggest
                                                the situation is beyond you, or you don't
                                                care anyway!</p>
                                            <div className="border_subtitle">Breathe!</div>
                                            <p>Taking deep breaths really does help to calm nervousness.
                                                Prepare yourself before an assertive
                                                encounter by taking some slow, deep breaths.</p>

                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcenter">
                                                <div className="border_subtitle">Refusing requests</div>
                                                <p>This is often difficult, so while you're weighing things
                                                    up, consider the following:</p>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>Your `gut' feeling usually tells you whether you
                                                        want to agree to or refuse a request.</p></li>
                                                    <li><p>If you're not sure, ask for more details so you
                                                        know what you're really committing
                                                        yourself to.</p></li>
                                                    <li><p>Don't be afraid to say `No' rather than deferring
                                                        to a higher authority.</p></li>
                                                    <li><p>Make it clear you're refusing the request, not
                                                        the person, the role, the job or
                                                        the friendship.</p></li>
                                                    <li><p>If you feel guilty when you say `No' to something
                                                        you don't want to do,
                                                        think of it as saying `Yes' to yourself – your self
                                                        worth.</p></li>
                                                    <li className="cntareap"><p>Saying `No', and surviving
                                                        the guilt, gets easier &shy; just keep
                                                        practising!</p></li>
                                                </ul>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}